import React from "react";
import PropTypes from "prop-types";
import { Button } from "components/common/button";

export const TourMenu = ({ totalCount, onStartTour, pendingDocumentCount }) => (
  <div>
    <h3>Walkthrough guides:</h3>
    <Button link onClick={ () => onStartTour("overview") }>App Overview</Button>
    { renderUpload(pendingDocumentCount, onStartTour) }
    <Button link onClick={ () => onStartTour("manual") }>Manual processing</Button>
    { renderDocuments(totalCount, onStartTour) }
    <Button link onClick={ () => onStartTour("automate") }>Automation</Button>
  </div>
);

TourMenu.propTypes = {
  onStartTour: PropTypes.func.isRequired,
  pendingDocumentCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired
};

const renderUpload = (pendingDocumentCount, onStartTour) => {
  if (pendingDocumentCount === 0) {
    return null;
  }
  return <Button link onClick={ () => onStartTour("upload") }>Upload documents</Button>;
};

const renderDocuments = (totalCount, onStartTour) => {
  if (totalCount === 0) {
    return null;
  }
  return <Button link onClick={ () => onStartTour("documents") }>View and edit documents</Button>;
};



// WEBPACK FOOTER //
// ./src/js/components/tours/tour-menu.jsx